module.exports = __webpack_public_path__ + "static/media/car_right.650a2f73.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/car_right.png
// module id = 338
// module chunks = 0